import React, { useState, useEffect } from "react";
import "./login.css";
import { useDispatch } from "react-redux";
import { setTokenFunction } from "../../../redux/Actions/UserAction";
import hrlogo from "../../assets/images/hrlogo.png";
import { useGoogleLogin } from "@react-oauth/google";
import apiEndpoints from "../../API/apiEndpoints";
import apiCall from "../../API/apiService";
import { PromptHireLogo } from "../../assets/svgComponent";
import { Input, Button , Card, Row, Col } from "antd";
import { LoginOutlined } from '@ant-design/icons';

const Login = () => {
  const dispatch = useDispatch();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [initialLoading, setInitialLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("accessToken");
    if (token) {
      dispatch(setTokenFunction(true));
    }
    setInitialLoading(false);
  }, [dispatch]);

  const handleLoginSuccess = async (tokenResponse) => {
    try {
      const res = await fetch(apiEndpoints.LOGIN, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          googleAccessToken: tokenResponse?.access_token,
        }),
      });

      if (res.ok) {
        const data = await res.json();
        const accessToken = data.accessToken;
        localStorage.setItem("accessToken", accessToken);
        localStorage.setItem("isAgentYugaStaff", data.is_agentyuga_staff);
        localStorage.setItem("username", username);
        dispatch(setTokenFunction(true));
      } else {
        setError("Failed to verify Google token. Please try again.");
        console.error("Failed to verify token:", res.statusText);
      }
    } catch (error) {
      setError("Error during Google login. Please try again.");
      console.error("Error during Google login:", error);
    }
  };

  // // const googleLogin = useGoogleLogin({
  //     onSuccess: handleLoginSuccess,
  //     onError: (error) => {
  //         setError("Google Login Failed. Please try again.");
  //         console.log("Login Failed:", error);
  //     },
  // });

  const handleUsernamePasswordLogin = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const response = await apiCall("post", apiEndpoints.LOGIN, {
        username: username,
        password: password,
      });

      if (response.access_token) {
        localStorage.setItem("accessToken", response.access_token);
        localStorage.setItem("isAgentYugaStaff", response.is_agentyuga_staff);
        localStorage.setItem("username", username);
        dispatch(setTokenFunction(true));
      } else {
        setError("Login failed. Please check your credentials and try again.");
        console.error("Login failed:", response.statusText);
      }
    } catch (error) {
      setError("An error occurred during login. Please try again.");
      console.error("Login error:", error);
    } finally {
      setLoading(false);
    }
  };

  if (initialLoading) {
    return null; // Return nothing during initial check
  }

  return (
    <div className="wrapper">
      <div className="area">
        <ul className="circles">
          {[...Array(10)].map((_, index) => (
            <li key={index}></li>
          ))}
        </ul>
      </div>
      <div className="login-content">
        <div
          style={{
            gap: 10,
            display: "flex",
            alignItems: "center",
            marginBottom: 20,
          }}
        >
          <img src={PromptHireLogo} style={{ width: 40, height: 40 }} />
          <span
            style={{
              color: "#000000",
              fontSize: 22,
              fontWeight: "600",
              fontFamily: "Inter",
            }}
          >
            PromptHire
          </span>
        </div>
        
        <div className="login-container" style={{ width: 350, borderRadius: 10, padding: 30 }}>
          {error && <div className="error-message">{error}</div>}
          {loading ? (
            <div className="loader"></div>
          ) : (
            <form onSubmit={handleUsernamePasswordLogin} className="login-form">
            <Row gutter={[0, 20]}>
              <Col span={24}>
                <Input
                  type="text"
                  placeholder="Username"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  required
                  style={{ height: 40, borderRadius: 10 }}
                />
              </Col>
              <Col span={24}>
                <Input.Password
                  placeholder="Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  style={{ height: 40, borderRadius: 10 }}
                />
              </Col>
              <Col span={24}>
                <Button 
                  type="primary" 
                  htmlType="submit" 
                  loading={loading} 
                  icon={<LoginOutlined />} 
                  style={{ width: '100%', height: 40, borderRadius: 10, fontSize: '16px', paddingTop: 4.5 }}
                >
                  Login
                </Button>
              </Col>
            </Row>
          </form>
          )}
        </div>
      </div>
      <style jsx>{`
        .area {
          position: absolute;
          width: 100%;
          height: 100vh;
          background: linear-gradient(to bottom, #4e54c8, #8f94fb);
          z-index: -1;
        }
        
        .circles {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          overflow: hidden;
          margin: 0;
          padding: 0;
        }
        
        .circles li {
          position: absolute;
          display: block;
          list-style: none;
          width: 20px;
          height: 20px;
          background: rgba(255, 255, 255, 0.2);
          animation: animate 25s linear infinite;
          bottom: -150px;
          border-radius: 50%;
        }
        
        .circles li:nth-child(1) {
          left: 25%;
          width: 80px;
          height: 80px;
          animation-delay: 0s;
        }
        
        .circles li:nth-child(2) {
          left: 10%;
          width: 20px;
          height: 20px;
          animation-delay: 2s;
          animation-duration: 12s;
        }
        
        .circles li:nth-child(3) {
          left: 70%;
          width: 20px;
          height: 20px;
          animation-delay: 4s;
        }
        
        .circles li:nth-child(4) {
          left: 40%;
          width: 60px;
          height: 60px;
          animation-delay: 0s;
          animation-duration: 18s;
        }
        
        .circles li:nth-child(5) {
          left: 65%;
          width: 20px;
          height: 20px;
          animation-delay: 0s;
        }
        
        .circles li:nth-child(6) {
          left: 75%;
          width: 110px;
          height: 110px;
          animation-delay: 3s;
        }
        
        .circles li:nth-child(7) {
          left: 35%;
          width: 150px;
          height: 150px;
          animation-delay: 7s;
        }
        
        .circles li:nth-child(8) {
          left: 50%;
          width: 25px;
          height: 25px;
          animation-delay: 15s;
          animation-duration: 45s;
        }
        
        .circles li:nth-child(9) {
          left: 20%;
          width: 15px;
          height: 15px;
          animation-delay: 2s;
          animation-duration: 35s;
        }
        
        .circles li:nth-child(10) {
          left: 85%;
          width: 150px;
          height: 150px;
          animation-delay: 0s;
          animation-duration: 11s;
        }
        
        @keyframes animate {
          0% {
            transform: translateY(0) rotate(0deg);
            opacity: 1;
            border-radius: 0;
          }
          100% {
            transform: translateY(-1000px) rotate(720deg);
            opacity: 0;
            border-radius: 50%;
          }
        }
        
        .login-content {
          position: relative;
          z-index: 1;
          display: flex;
          flex-direction: column;
          align-items: center;
        }
        
        .login-container {
          background-color: rgba(255, 255, 255, 0.9);
          backdrop-filter: blur(10px);
          box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.37);
          transition: transform 0.3s ease, box-shadow 0.3s ease;
        }
        
        .login-container:hover {
          transform: translateY(-5px);
          box-shadow: 0 15px 35px 0 rgba(31, 38, 135, 0.47);
        }

        .login-form input {
          padding: 12px;
          border: 1px solid #ccc;
          border-radius: 8px;
          font-size: 16px;
          transition: border-color 0.3s ease, box-shadow 0.3s ease;
        }

        .login-form input:focus {
          border-color: #4e54c8;
          box-shadow: 0 0 5px rgba(78, 84, 200, 0.5);
          outline: none;
        }

        .login-form button {
          background-color: #4e54c8;
          color: white;
          font-size: 16px;
          border: none;
          border-radius: 8px;
          padding: 12px;
          transition: background-color 0.3s ease, transform 0.3s ease;
        }

        .login-form button:hover {
          background-color: #3b3f8c;
          transform: translateY(-2px);
        }
      `}</style>
    </div>
  );
};

export default Login;
